import { FormDialog } from "../../components/FormDialog/FormDialog";

const CompanyDialog = ({ formId, saveCompanyData, companySchema, uiSchema, formData, handleFormChange, readOnly }) => {

    function customValidate(formData, errors, uiSchema) {
        if (formData.idpOutputLocation && formData.idpOutputBackupLocation) {
            if (formData.idpOutputLocation === formData.idpOutputBackupLocation) {
                errors.idpOutputLocation.addError("IDP Output Location and IDP Output Backup Location can't be same");
            } else if (formData.idpOutputLocation.split("://")[0] !== formData.idpOutputBackupLocation.split("://")[0]) {
                errors.idpOutputLocation.addError("IDP Output Location and IDP Output Backup Location should start with same value");
            }
        }
        return errors;
    }

    return (
        <FormDialog formId={formId}
            formData={formData}
            schema={companySchema}
            uiSchema={uiSchema}
            handleFormChange={handleFormChange}
            readOnly={readOnly}
            saveFormData={saveCompanyData}
            customValidate={customValidate}
        />
    );
};

export default CompanyDialog;
